import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import {
  createIdentityAPIEndpoint,
  EndPoints,
} from "../../../services/AuthServices";
import { BASE_URL_STRING } from "../../../services/axios";

const LessonPlayer = () => {
  const { id } = useParams();
  const [bunnyVideoId, setBunnyVideoId] = useState(null);
  const [isVideoActive, setIsVideoActive] = useState(false);
  const wrapperRef = useRef(null);
  const [userName, setUserName] = useState("");
  const [watermarkPosition, setWatermarkPosition] = useState({
    top: 20,
    left: 20,
  });
  const [currentTime, setCurrentTime] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  // حركة العلامة المائية (Watermark) العشوائية
  useEffect(() => {
    const interval = setInterval(() => {
      setWatermarkPosition({
        top: Math.floor(Math.random() * 70),
        left: Math.floor(Math.random() * 70),
      });
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  // تحديث الوقت الحالي للعلامة المائية
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date().toLocaleTimeString());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  // جلب بيانات الدرس (الـ Bunny VideoId) واسم المستخدم
  useEffect(() => {
    const fetchLessonData = async () => {
      try {
        const token = sessionStorage.getItem("token");
        const { data } = await axios.get(
          `${BASE_URL_STRING}v1/Lessons/generate-stream-url/${id}`,
          { headers: { Authorization: `Bearer ${token}` } },
        );
        // نفترض أن الـ data.videoUrl أصبح يخزن الـ VideoId القادم من Bunny
        setBunnyVideoId(data.url);
      } catch (error) {
        console.error("Error lesson data:", error);
        const message =
          error.response?.data?.message || "You cannot access this lesson.";

        setErrorMessage(message);
      }
    };
    getUserName();
    fetchLessonData();
  }, [id]);

  // مراقبة الخروج من وضع الـ Fullscreen
  useEffect(() => {
    const handleFullscreenChange = () => {
      if (!document.fullscreenElement && !document.webkitFullscreenElement) {
        const confirmed = window.confirm(
          "سيتم إيقاف الفيديو واحتساب المشاهدة، هل أنت متأكد؟",
        );
        if (confirmed) {
          navigate("/my-lessons");
        } else {
          wrapperRef.current?.requestFullscreen();
        }
      }
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange,
      );
    };
  }, [navigate]);

  const getUserName = () => {
    createIdentityAPIEndpoint(EndPoints.details)
      .fetch()
      .then((res) => {
        setUserName(res.data.fullName);
      })
      .catch((err) => {
        console.log("Error fetching user details:", err);
      });
  };

  const handleEnableVideo = () => {
    setIsVideoActive(true);
    setTimeout(() => {
      const element = wrapperRef.current;
      if (element) {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullscreen) {
          element.webkitRequestFullscreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        }
      }
    }, 100);
  };
  if (errorMessage) {
    return (
      <div
        className="video-page"
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "20px",
        }}
      >
        <div
          style={{
            textAlign: "center",
            maxWidth: "500px",
            padding: "40px 30px",
            borderRadius: "16px",
            background: "#fff",
            boxShadow: "0 8px 30px rgba(0,0,0,0.12)",
          }}
        >
          <div
            style={{
              fontSize: "50px",
              marginBottom: "15px",
            }}
          >
            🔒
          </div>

          <h2>Lesson Unavailable</h2>

          <p
            style={{
              color: "#666",
              lineHeight: 1.7,
              marginBottom: "25px",
            }}
          >
            {errorMessage}
          </p>

          <button
            className="resume-btn"
            onClick={() => navigate("/my-lessons")}
          >
            Back to My Lessons
          </button>
        </div>
      </div>
    );
  }
  return (
    <div className="video-page">
      {bunnyVideoId ? (
        isVideoActive ? (
          <div
            className="video-wrapper"
            ref={wrapperRef}
            style={{
              position: "relative",
              width: "100%",
              height: "100vh",
              background: "#000",
            }}
          >
            <iframe
              src={`https://iframe.mediadelivery.net/embed/783332/${bunnyVideoId}?autoplay=true&loop=false&muted=false&preload=true`}
              loading="lazy"
              style={{
                border: "none",
                position: "absolute",
                top: 0,
                height: "100%",
                width: "100%",
              }}
              allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
              allowFullScreen={true}
              title="Lesson Video Player"
            ></iframe>

            <div
              className="video-overlay"
              style={{
                pointerEvents: "none",
                position: "absolute",
                zIndex: 9999,
              }}
            >
              <span
                className="video-username"
                style={{
                  position: "fixed",
                  top: `${watermarkPosition.top}%`,
                  left: `${watermarkPosition.left}%`,
                  color: "rgba(255, 255, 255, 0.5)",
                  fontSize: "18px",
                  fontWeight: "bold",
                  textShadow: "1px 1px 2px black",
                }}
              >
                {userName}
                <br />
                {currentTime}
              </span>
            </div>
          </div>
        ) : (
          <div className="resume-container">
            <button className="resume-btn" onClick={handleEnableVideo}>
              ▶ Resume Lesson
            </button>
          </div>
        )
      ) : (
        <p>Loading Lesson...</p>
      )}
    </div>
  );
};

export default LessonPlayer;
